import { sevColor } from '../../lib/severity';
import { RuleIcon } from '../../lib/ruleIcons';
import type { Cluster } from './clustering';

/**
 * Aggregated marker for several same-rule alerts that sit close together: a
 * larger avatar disc bearing the rule glyph + a count badge, tinted by the
 * cluster's most-severe severity. Clicking opens the aggregated popup.
 */
export function ClusterPin({ cluster, onSelect }: { cluster: Cluster; onSelect?: () => void }) {
  const color = sevColor(cluster.topSeverity);

  return (
    <div style={{ position: 'relative', width: 0, height: 0 }}>
      <span
        className="pin-wave"
        style={{ left: -18, top: -18, width: 36, height: 36, ['--ring-color' as string]: color }}
      />
      <span
        role="button"
        tabIndex={0}
        aria-label={`${cluster.alerts.length} ${cluster.ruleId} alerts — open cluster`}
        onClick={onSelect}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onSelect?.();
          }
        }}
        style={{
          position: 'absolute',
          left: -16,
          top: -16,
          width: 32,
          height: 32,
          borderRadius: '50%',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          color,
          background: 'var(--surface-app)',
          border: `2px solid ${color}`,
          boxShadow: `0 0 8px ${color}`,
          cursor: 'pointer',
        }}
      >
        <RuleIcon ruleId={cluster.ruleId} size={15} />
      </span>
      <span
        className="mono"
        style={{
          position: 'absolute',
          left: 6,
          top: -20,
          minWidth: 16,
          height: 16,
          padding: '0 4px',
          borderRadius: 8,
          background: color,
          color: 'var(--surface-app)',
          fontSize: 10,
          fontWeight: 700,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'none',
        }}
      >
        {cluster.alerts.length}
      </span>
    </div>
  );
}
